import {Component, inject, computed} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslocoPipe} from '@jsverse/transloco';
import {
  InvitationOfferOverviewResponse,
  ProviderTenantMappingResponse,
  GetInvitationOfferOverviewsRequestParams,
  RfqControllerService,
} from '@frontend/shared-api';
import {rxResource} from '@angular/core/rxjs-interop';
import {Panel} from 'primeng/panel';
import {ReactiveFormsModule} from '@angular/forms';
import {TableModule} from 'primeng/table';
import {of} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {AppCurrencyPipe} from '@frontend/shared';
import {TotalFeeData} from '../../step-8-2-invitation-preview/step-8-2-3-rfq-price-list/total-fees/total-fees.types';
import {Step823RfqPreviewPriceListComponent} from '../../step-8-2-invitation-preview/step-8-2-3-rfq-price-list/step-8-2-3-rfq-preview-price-list.component';
import {NoDataComponent} from '../../../../../../../shared/components/no-data/no-data.component';
import {LoadingComponent} from '../../../../../../../shared/components/loading/loading.component';
import {ProjectStepBaseReactive} from '../../../../project-base-step/project-base-step-reactive.component';
import {CardTitleComponent} from '../../../../../../../shared/components/header/card-title/card-title.component';

export interface ProviderTendersVM {
  providerTenantMappingResponse: ProviderTenantMappingResponse;
  invitationOfferOverviewResponse: InvitationOfferOverviewResponse;
  totalFeeData: TotalFeeData;
}

@Component({
  selector: 'app-step-8-4-1-rfq-provider-results-price-list',
  imports: [
    CommonModule,
    TranslocoPipe,
    Panel,
    ReactiveFormsModule,
    TableModule,
    Step823RfqPreviewPriceListComponent,
    NoDataComponent,
    AppCurrencyPipe,
    LoadingComponent,
    CardTitleComponent,
  ],
  templateUrl: './step-8-4-1-provider-results-price-list.component.html',
})
export class Step841ProviderResultsPriceListComponent extends ProjectStepBaseReactive {
  private readonly rfqController = inject(RfqControllerService);

  readonly invitationOfferOverviewsResource = rxResource({
    params: () => ({
      projectId: this.projectId()!,
    }),
    stream: ({params: request}) => {
      return this.rfqController
        .getInvitationOfferOverviews({
          projectId: request.projectId,
        } as GetInvitationOfferOverviewsRequestParams)
        .pipe(
          catchError((err) => {
            console.error('Error loading invitation overviews', err);
            return of([]);
          }),
        );
    },
  });

  readonly rowVM = computed<ProviderTendersVM[]>(() => {
    const overviews = this.invitationOfferOverviewsResource.value() ?? [];
    return overviews.map(
      (item) =>
        ({
          providerTenantMappingResponse: item.providerTenantMappingResponse,
          invitationOfferOverviewResponse: item.invitationOfferOverviewResponse,
        }) as ProviderTendersVM,
    );
  });

  protected updateTotalFeesCard(item: ProviderTendersVM, $event: TotalFeeData) {
    item.totalFeeData = $event;
  }
}
